<div class="flex flex-col h-screen overflow-hidden">
  <div class="px-6 pt-4 pb-2 flex-shrink-0">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">{{ isEditMode ? 'Edição' : 'Cadastro' }} de Template de OS</h1>
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4">
    <div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto bg-white">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    
    <!-- Informações Básicas -->
    <div class="space-y-4">
      <h3 class="text-lg font-semibold text-gray-700 border-b pb-2">Informações Básicas</h3>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="md:col-span-2">
          <label class="block mb-1 font-medium">Nome do Template <span class="text-red-500">*</span></label>
          <input 
            pInputText
            type="text" 
            formControlName="name"
            placeholder="Ex: Template Mecânica Automotiva"
            class="w-full"
            [ngClass]="{'ng-invalid ng-dirty': form.get('name')?.invalid && form.get('name')?.touched}">
          <small class="text-red-500" *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
            Nome é obrigatório
          </small>
        </div>
      </div>
    </div>

    <!-- Tabs para Checklist e Campos Personalizados -->
    <p-tabview [(activeIndex)]="activeTabIndex">
      
      <!-- Aba 1: Checklist -->
      <p-tabpanel header="Checklist">
        <div class="mt-4">
          <div class="flex justify-between items-center mb-4">
            <div>
              <h4 class="font-semibold text-gray-700">Itens do Checklist</h4>
              <p class="text-sm text-gray-500">Itens que serão incluídos quando uma OS for criada a partir deste template</p>
            </div>
            <button 
              type="button"
              (click)="addChecklistItem()"
              class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded text-sm">
              <i class="pi pi-plus mr-2"></i>
              Adicionar Item
            </button>
          </div>

          <div class="max-h-[500px] overflow-y-auto pr-2">
            <div *ngIf="checklistItems.length === 0" class="text-center py-8 text-gray-500">
              Nenhum item adicionado. Clique em "Adicionar Item" para começar.
            </div>
            
            <div *ngIf="checklistItems.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div *ngFor="let item of checklistItems; let i = index" 
                   class="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border">
                
                <div class="flex-1">
                  <input 
                    pInputText
                    type="text"
                    [(ngModel)]="item.text"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Digite o texto do item..."
                    class="w-full">
                </div>

                <div class="flex items-center gap-2">
                  <p-button 
                    icon="pi pi-arrow-up" 
                    [rounded]="true"
                    [text]="true"
                    [disabled]="i === 0"
                    (onClick)="moveItemUp(i)"
                    pTooltip="Mover para cima"
                    tooltipPosition="top">
                  </p-button>
                  <p-button 
                    icon="pi pi-arrow-down" 
                    [rounded]="true"
                    [text]="true"
                    [disabled]="i === checklistItems.length - 1"
                    (onClick)="moveItemDown(i)"
                    pTooltip="Mover para baixo"
                    tooltipPosition="top">
                  </p-button>
                  <p-button 
                    icon="pi pi-trash" 
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    (onClick)="removeChecklistItem(i)"
                    pTooltip="Remover"
                    tooltipPosition="top">
                  </p-button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4 flex items-center gap-4">
            <span class="text-sm text-gray-600">
              <strong>{{ checklistItemsCount }}</strong> item(ns) válido(s)
            </span>
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 2: Campos Personalizados -->
      <p-tabpanel header="Campos Personalizados">
        <div class="mt-4">
          <div class="flex justify-between items-center mb-4">
            <div>
              <h4 class="font-semibold text-gray-700 mb-2">Campos Personalizados</h4>
              <p class="text-sm text-gray-500">
                Campos que serão incluídos quando uma OS for criada a partir deste template
              </p>
            </div>
            <button 
              type="button"
              (click)="openNewFieldModal()"
              pButton
              label="Novo Campo"
              icon="pi pi-plus"
              class="p-button-sm p-button-outlined">
            </button>
          </div>

          <!-- Lista de campos criados -->
          <div class="max-h-[500px] overflow-y-auto pr-2">
            <div *ngIf="customFields.length === 0" class="text-center py-8 text-gray-500">
              Nenhum campo criado. Clique em "Novo Campo" para criar campos.
            </div>

            <div *ngIf="customFields.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div *ngFor="let field of customFields; let i = index" 
                   class="flex flex-col gap-3 p-4 bg-white rounded-lg border border-gray-200">
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-2 flex-wrap">
                    <span class="font-medium text-gray-700">{{ field.label }}</span>
                    <span class="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                      {{ getFieldTypeLabel(field.fieldType) }}
                    </span>
                    <span *ngIf="field.required" class="px-2 py-1 bg-red-100 text-red-800 rounded text-xs">
                      Obrigatório
                    </span>
                  </div>
                  <div *ngIf="field.fieldType === 'DROPDOWN' && field.options && field.options.length > 0" class="mt-2">
                    <p class="text-xs text-gray-500 mb-1">Opções:</p>
                    <div class="flex flex-wrap gap-1">
                      <span *ngFor="let option of field.options" 
                            class="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
                        {{ option }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="flex items-center gap-2 justify-end">
                  <p-button 
                    icon="pi pi-arrow-up" 
                    [rounded]="true"
                    [text]="true"
                    [disabled]="i === 0"
                    (onClick)="moveFieldUp(i)"
                    pTooltip="Mover para cima"
                    tooltipPosition="top">
                  </p-button>
                  <p-button 
                    icon="pi pi-arrow-down" 
                    [rounded]="true"
                    [text]="true"
                    [disabled]="i === customFields.length - 1"
                    (onClick)="moveFieldDown(i)"
                    pTooltip="Mover para baixo"
                    tooltipPosition="top">
                  </p-button>
                  <p-button 
                    icon="pi pi-trash" 
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    (onClick)="removeCustomField(i)"
                    pTooltip="Remover"
                    tooltipPosition="top">
                  </p-button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4 flex items-center gap-4">
            <span class="text-sm text-gray-600">
              <strong>{{ customFieldsCount }}</strong> campo(s) criado(s)
            </span>
          </div>
        </div>
      </p-tabpanel>

    </p-tabview>

    <!-- Botões -->
    <div class="flex justify-end gap-3 mt-6">
      <button (click)="cancel()" type="button" class="border px-4 py-2 border-orange-500 cursor-pointer rounded hover:bg-orange-50" [disabled]="loading">
        Cancelar
      </button>
      <button
        type="submit"
        class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white disabled:bg-gray-400 disabled:cursor-not-allowed"
        [disabled]="form.invalid || loading"
      >
        <span *ngIf="loading" class="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></span>
        {{ isEditMode ? 'Salvar' : 'Criar Template' }}
      </button>
    </div>

    </form>
  </div>
</div>

<!-- Modal para criar novo campo -->
<p-dialog 
  [(visible)]="showNewFieldModal" 
  [modal]="true" 
  [style]="{width: '600px'}"
  header="Novo Campo Personalizado"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{'overflow': 'visible'}"
  [baseZIndex]="10000">
  
  <div class="space-y-4">
    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Label <span class="text-red-500">*</span></label>
      <input 
        pInputText
        type="text"
        [(ngModel)]="newFieldLabel"
        [ngModelOptions]="{standalone: true}"
        placeholder="Ex: Placa do Veículo"
        class="w-full">
    </div>
    
    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Tipo <span class="text-red-500">*</span></label>
      <p-dropdown
        [options]="fieldTypes"
        [(ngModel)]="newFieldType"
        [ngModelOptions]="{standalone: true}"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione o tipo"
        [appendTo]="'body'"
        class="w-full"
        styleClass="w-full">
      </p-dropdown>
    </div>

    <div>
      <label class="flex items-center gap-2 cursor-pointer">
        <input 
          type="checkbox"
          [(ngModel)]="newFieldRequired"
          [ngModelOptions]="{standalone: true}"
          class="w-4 h-4">
        <span class="text-sm font-medium text-gray-700">Campo obrigatório</span>
      </label>
    </div>

    <!-- Opções do Dropdown -->
    <div *ngIf="newFieldType === 'DROPDOWN'" class="space-y-2">
      <label class="block text-sm font-medium text-gray-700">Opções do Dropdown <span class="text-red-500">*</span></label>
      <div class="flex gap-2">
        <input 
          pInputText
          type="text"
          [(ngModel)]="newFieldOptionText"
          [ngModelOptions]="{standalone: true}"
          placeholder="Digite uma opção e pressione Enter"
          class="flex-1"
          (keyup.enter)="addDropdownOption()">
        <button 
          type="button"
          (click)="addDropdownOption()"
          pButton
          label="Adicionar"
          icon="pi pi-plus"
          class="p-button-sm">
        </button>
      </div>
      <div *ngIf="newFieldOptions.length > 0" class="flex flex-wrap gap-2 mt-2">
        <span *ngFor="let option of newFieldOptions; let i = index" 
              class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm flex items-center gap-2">
          {{ option }}
          <button 
            type="button"
            (click)="removeDropdownOption(i)"
            class="text-blue-600 hover:text-blue-800">
            <i class="pi pi-times text-xs"></i>
          </button>
        </span>
      </div>
      <small class="text-gray-500">Adicione pelo menos uma opção para o dropdown</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button 
      type="button"
      (click)="closeNewFieldModal()"
      pButton
      label="Cancelar"
      icon="pi pi-times"
      class="p-button-text">
    </button>
    <button 
      type="button"
      (click)="addCustomField()"
      pButton
      label="Adicionar Campo"
      icon="pi pi-check"
      class="p-button-primary">
    </button>
  </ng-template>
</p-dialog>

<p-toast />

